/**
 * The link to "Supported languages and frameworks" (pages/SupportedStacks.jsx), for the places a person picks how
 * something runs: Add service, Apps › How it runs, the AI tool connection steps, the in-context "not supported" notes.
 * A click opens the big dialog in place (SupportedStacksModal.jsx), so a dialog or a half-made choice stays where it
 * is; without the dialog's host it is a plain link to the page. `stack`: the row to point at.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { stacksHref } from '../../utils/stacksModel';
import { openSupportedStacks } from './supportedStacksDialog';

export default function SupportedStacksLink({ children = 'What can Flow run?', stack = null, className = undefined, testId = 'supported-stacks-link' }) {
  const onClick = (event) => {
    // A modified click (a new tab or window, on purpose) is the browser's.
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) { return; }
    if (openSupportedStacks(stack)) { event.preventDefault(); }
  };
  return (
    <a aria-haspopup="dialog" className={className} data-testid={testId} href={stacksHref(stack)} onClick={onClick}>
      {children}
    </a>
  );
}

SupportedStacksLink.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  stack: PropTypes.string,
  testId: PropTypes.string,
};
